import { ui } from '@procuros/datachecks';

/**
 * Typed constants for the datachecks uiConfig section types we route on.
 *
 * The `satisfies` clause enforces every value here is a valid `ui.Section['type']`
 * at compile time — adding a typo or a stale section name fails typecheck.
 *
 * Use these instead of bare string literals when:
 * - Checking `normalizedPath.startsWith(...)` in the resolver dispatcher
 * - Comparing `uiConfig.find((s) => s.type === ...)` to a known section
 * - Building flat-data prefixes like `info.0.<scalar>`
 *
 * Derived types `SectionTypeKey` / `SectionTypeValue` live in `webediErrors/types.ts`
 * alongside the other webediErrors public type exports.
 */
export const SECTION_TYPES = {
  PARTIES: 'parties',
  LINE_ITEMS: 'line_items',
  INFO: 'info',
} as const satisfies Record<string, ui.Section['type']>;
